// extracted by mini-css-extract-plugin
module.exports = {"root":"Articles_root__3wjuS"};